<template>
  <div class="container">
    <div v-if="!claudeKey || changingClaudeKey">
      <div class="field mt-6">
        <label class="label">Claude API Key</label>
        <div class="control">
          <textarea class="textarea" placeholder="Claude API Key" v-model="newClaudeKey" ></textarea>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" @click="setClaudeKey">Save</button>
        </div>
        <div class="control">
          <button class="button is-link is-light" @click="cancelSetClaudeKey">Cancel</button>
        </div>
      </div>
    </div>

    <div>
      <button v-if="!changingClaudeKey" class="button is-pulled-right mt-3" @click="changingClaudeKey = true">
        <i class="fas fa-key"></i>
      </button>
      <chat-agent :claudeKey="claudeKey" />
    </div>
  </div>
</template>

<script>
import ChatAgent from '@/components/chat-agent/ChatAgent'

export default {
  name: 'ChatView',
  components: {
    ChatAgent
  },
  data () {
    return {
      claudeKey: '',
      newClaudeKey: '',
      changingClaudeKey: false,
    }
  },
  computed: {
    
  },
  methods: {
    setClaudeKey () {
      this.newClaudeKey = this.newClaudeKey.trim()
      this.claudeKey = this.newClaudeKey
      localStorage.setItem('claudeKey', this.newClaudeKey)
      this.changingClaudeKey = false
    },
    cancelSetClaudeKey () {
      this.newClaudeKey = this.claudeKey
      this.changingClaudeKey = false
    },
  },
  mounted () {
    var claudeKey = localStorage.getItem('claudeKey')
    if (claudeKey) {
      this.claudeKey = claudeKey
      this.newClaudeKey = claudeKey
    }
  },
}
</script>
